module.exports = __webpack_public_path__ + "img/shape-6-gold@2x.b61ba66b.png";